export const STEP_STUDIES_ACTION_TYPES = {
  STEP_STUDIES_ADDED_STATE: 'STEP_STUDIES_ADDED_STATE',
  STEP_STUDIES_ALL: 'STEP_STUDIES_ALL',
  STEP_STUDIES_CHANGE_PROCESSING: 'STEP_STUDIES_CHANGE_PROCESSING',
};

export function addSelectStudiesData(data) {
  return {
    type: STEP_STUDIES_ACTION_TYPES.STEP_STUDIES_ADDED_STATE,
    payload: data,
  };
}

export function getStepStudiesData(url) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeFormProcessingState(true));

    const response = await axios.get(url);

    dispatch(changeFormProcessingState(false));

    if (!response || response.code !== 'success') {
      return response;
    }

    const { data } = response;

    dispatch({
      type: STEP_STUDIES_ACTION_TYPES.STEP_STUDIES_ALL,
      payload: {
        data,
      },
    });

    return response;
  };
}

export function sendStudieData(url, body) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeFormProcessingState(true));

    const response = await axios.post(url, body);

    dispatch(changeFormProcessingState(false));

    if (!response || response.code !== 'success') {
      return response;
    }

    const { data } = response;

    dispatch({
      type: STEP_STUDIES_ACTION_TYPES.STEP_STUDIES_ALL,
      payload: {
        data,
      },
    });

    return response;
  };
}

export function changeFormProcessingState(newState) {
  return {
    type: STEP_STUDIES_ACTION_TYPES.STEP_STUDIES_CHANGE_PROCESSING,
    payload: newState,
  };
}
